/* ============
 * Overlay Status Mixin
 * ============
 *
 * Mixins are used to easily expand Vue components.
 * This slot-mixin, will add the hasSlot-method
 * to the specified Vue component.
 */

export default {
  data() {
    return {
      overlayStatus: false,
    };
  },
  methods: {
    toggleOverlayStatus(value) {
      this.$store.dispatch(
        'exteriors/toggleShowOverlayStatus',
        typeof value === 'boolean' ? value : undefined,
      );
    },
  },
};
